angular.module('billing').controller('TransactionCompleteCtrl',
    ['$window',
        function ($window) {
            'use strict';

            // right now this is just sent to a target of the same origin as this window
            $window.parent.postMessage({
                eventName: 'tc-redirectUrl',
                data: $window.location.href,
            }, $window.location.origin);

        }]);